/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifact_Landing_No_Access_DescriptionInputs */



/**
* | output |
* | --- |
* | "This artifact belongs to a project you're not a member of. Request access from its owner to view it." |
*
* @param {Artifact_Landing_No_Access_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_landing_no_access_description = /** @type {((inputs?: Artifact_Landing_No_Access_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Landing_No_Access_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieses Artefakt gehört zu einem Projekt, in dem Sie kein Mitglied sind. Bitten Sie den Eigentümer um Zugriff, um es anzusehen.")
	return /** @type {LocalizedString} */ ("This artifact belongs to a project you're not a member of. Request access from its owner to view it.")
});